import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';

export const OfferLoadDetailsActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[offer] Load details'),
  requestFail: uniqueActionType('[offer] Load details fail'),
  requestSuccess: uniqueActionType('[offer] Load details success'),
  requestClearErrors: uniqueActionType('[offer] Load details clear errors'),
  requestClear: uniqueActionType('[offer] Load details clear')
};

export class OfferLoadDetailsAction implements PayloadAction {
  readonly type = OfferLoadDetailsActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class OfferLoadDetailsFailAction implements PayloadAction {
  readonly type = OfferLoadDetailsActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class OfferLoadDetailsSuccessAction implements PayloadAction {
  readonly type = OfferLoadDetailsActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class OfferLoadDetailsClearErrorsAction implements PayloadAction {
  readonly type = OfferLoadDetailsActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class OfferLoadDetailsClearAction implements PayloadAction {
  readonly type = OfferLoadDetailsActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
